import Navbar from "./components/Navbar/Navbar";
import EmergencyButton from "./components/EmergencyButton";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhyChooseUs from "./components/WhyChooseUs";
import Testimonials from "./components/Testimonials";
import ScrollProgress from "./components/ScrollProgress";

function App() {
  return (
    <>
      <Navbar />

      <main>
        <Hero />
        <Services />
        <About />
        <WhyChooseUs />
        <Testimonials />
        <Contact />
      </main>

      <Footer />
      <ScrollProgress />
      <EmergencyButton />

    </>
  );
}
export default App;